function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSnowing3 = function SvgSnowing3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M426.208,158.964c-1.12,0-42.648,0-42.648,0c0.744-8.16,1.24-9.968,1.256-14.744 c0.128-42.672-28.36-80.592-70.032-89.776c-23.752-5.232-46.424-1.68-65.184,8.44c-22.888-34.064-60.808-57.2-104.272-59.856 c-5.592-0.768-11.256-1.304-17.056-1.304C57.432,1.724,0,60.948,0,134.012c0,38.072,15.688,72.288,40.648,96.424 c22.072,24.488,52.72,40.304,89.008,42.936c0,0,295.432,1.464,296.552,1.464c29.712,0,53.792-25.936,53.792-57.928 C480,184.9,455.912,158.964,426.208,158.964z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M288.096,334.18c-2.048,0-4.096-0.784-5.656-2.344c-3.128-3.128-3.128-8.184,0-11.312 l111.816-111.816c3.128-3.128,8.184-3.128,11.312,0s3.128,8.184,0,11.312L293.752,331.836 C292.184,333.404,290.144,334.18,288.096,334.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M399.904,334.18c-2.048,0-4.096-0.784-5.656-2.344L282.44,220.028 c-3.128-3.128-3.128-8.184,0-11.312s8.184-3.128,11.312,0l111.816,111.816c3.128,3.128,3.128,8.184,0,11.312 C404,333.404,401.952,334.18,399.904,334.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M352,314.748v-89.152l21.936-21.864c3.128-3.12,3.144-8.184,0.016-11.32 c-3.12-3.128-8.176-3.144-11.312-0.016L352,203.004v-12.728c0-4.416-3.576-8-8-8s-8,3.584-8,8v12.712l-10.6-10.576 c-3.112-3.128-8.184-3.128-11.312,0.008c-3.12,3.128-3.12,8.192,0.016,11.312L336,225.596v89.152l-21.896,21.864 c-3.136,3.12-3.136,8.184-0.016,11.312c1.56,1.568,3.616,2.352,5.664,2.352s4.096-0.784,5.648-2.336l10.6-10.584v12.92 c0,4.416,3.576,8,8,8s8-3.584,8-8V337.34l10.64,10.608c3.144,3.128,8.2,3.104,11.312-0.016c3.128-3.128,3.112-8.192-0.016-11.32 L352,314.748z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4F1F4"
    },
    cx: 344.4,
    cy: 269.852,
    r: 29.824
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M344.424,307.676c-20.856,0-37.832-16.968-37.832-37.824c0-20.856,16.968-37.832,37.832-37.832 s37.832,16.968,37.832,37.832C382.248,290.708,365.28,307.676,344.424,307.676z M344.424,248.028 c-12.04,0-21.832,9.792-21.832,21.832s9.792,21.824,21.832,21.824s21.832-9.792,21.832-21.824S356.464,248.028,344.424,248.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M40.096,454.18c-2.048,0-4.096-0.784-5.656-2.344c-3.128-3.128-3.128-8.184,0-11.312 l111.816-111.816c3.128-3.128,8.184-3.128,11.312,0s3.128,8.184,0,11.312L45.752,451.836 C44.184,453.404,42.144,454.18,40.096,454.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M151.904,454.18c-2.048,0-4.096-0.784-5.656-2.344L34.44,340.028c-3.128-3.128-3.128-8.184,0-11.312 s8.184-3.128,11.312,0l111.816,111.816c3.128,3.128,3.128,8.184,0,11.312C156,453.404,153.952,454.18,151.904,454.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M424,262.276h-13.536l9.736-10.584c2.992-3.248,2.776-8.312-0.48-11.304 c-3.248-2.984-8.304-2.776-11.304,0.472l-19.68,21.416H298.6l-20.568-21.528c-3.048-3.184-8.112-3.32-11.304-0.256 c-3.192,3.056-3.312,8.12-0.256,11.312l10.008,10.472H264c-4.424,0-8,3.584-8,8s3.576,8,8,8h12.464l-11.04,10.992 c-3.136,3.12-3.152,8.176-0.032,11.312c1.56,1.568,3.616,2.352,5.672,2.352c2.04,0,4.088-0.776,5.64-2.336l22.432-22.32h89.656 l20.888,22.152c1.576,1.664,3.696,2.512,5.824,2.512c1.968,0,3.944-0.72,5.496-2.176c3.208-3.032,3.36-8.096,0.328-11.312 l-10.544-11.176H424c4.424,0,8-3.584,8-8S428.424,262.276,424,262.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M125.944,323.74c3.128-3.12,3.136-8.184,0.016-11.32c-3.12-3.128-8.184-3.136-11.32-0.016 L104,323.012v-12.736c0-4.416-3.584-8-8-8s-8,3.584-8,8v12.712l-10.6-10.584c-3.128-3.136-8.192-3.128-11.312,0.008 c-3.128,3.128-3.12,8.192,0.008,11.312L88,345.588v89.168L66.096,456.62c-3.128,3.12-3.136,8.184-0.008,11.312 c1.568,1.56,3.608,2.344,5.664,2.344c2.048,0,4.088-0.784,5.656-2.336L88,457.356v12.92c0,4.416,3.584,8,8,8s8-3.584,8-8v-12.944 l10.648,10.608c3.128,3.112,8.192,3.096,11.32-0.016c3.12-3.136,3.112-8.192-0.016-11.32L104,434.748v-89.152L125.944,323.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M176,382.276h-13.528l9.736-10.584c2.992-3.248,2.784-8.312-0.472-11.304 c-3.248-3-8.328-2.784-11.304,0.472l-19.696,21.416H50.608L30.04,360.748c-3.064-3.2-8.12-3.32-11.312-0.256 c-3.192,3.056-3.312,8.12-0.256,11.312l10,10.472H16c-4.416,0-8,3.584-8,8s3.584,8,8,8h12.456l-11.04,10.992 c-3.136,3.12-3.144,8.176-0.024,11.312c1.56,1.568,3.616,2.352,5.664,2.352c2.04,0,4.08-0.776,5.648-2.336l22.432-22.32h89.656 l20.888,22.152c1.576,1.664,3.696,2.512,5.824,2.512c1.968,0,3.944-0.72,5.488-2.176c3.216-3.032,3.36-8.096,0.336-11.312 l-10.544-11.176H176c4.416,0,8-3.584,8-8S180.416,382.276,176,382.276z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4F1F4"
    },
    cx: 96.4,
    cy: 389.852,
    r: 29.824
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDDE5"
    },
    d: "M96.424,427.676c-20.856,0-37.824-16.968-37.824-37.824c0-20.856,16.968-37.832,37.824-37.832 s37.832,16.968,37.832,37.832C134.248,410.708,117.28,427.676,96.424,427.676z M96.424,368.028 c-12.032,0-21.824,9.792-21.824,21.832s9.792,21.824,21.824,21.824s21.832-9.792,21.832-21.824S108.456,368.028,96.424,368.028z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnowing3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snowing-3.20df6662.svg";
export { ForwardRef as ReactComponent };